import "./Style.scss";
const Title = ({ title }) => <h1 className="title">{title}</h1>;

export default Title;
